import { createTheme, PaletteOptions, ThemeOptions, Theme } from '@mui/material'
import { useTheme as defaultUseTheme } from 'styled-components'
import { MuiButtonCustom, MuiTypographyCustom } from '@astro-ui/@muiOverrides'
import breakpoints from '@astro-ui/fondations/breakpoints'
import colors, { dsColor, DSColorType } from '@astro-ui/fondations/colors'
import { elevation, shadowsArray, shadowValue } from '@astro-ui/fondations/elevation'
import { radius } from '@astro-ui/fondations/radii'
import { spacing } from '@astro-ui/fondations/spacing'
import { textVariant } from '@astro-ui/fondations/text'
import fondations from '@astro-ui/fondations'

export const themeOptions: ThemeOptions = {
  ...fondations,
  colors,
  elevation,
  spacing,
  radius,
  textVariant,
  breakpoints,
  shadows: {
    ...shadowValue,
    ...shadowsArray,
  },
  components: {
    ...MuiButtonCustom,
    ...MuiTypographyCustom,
  },
  palette: {
    ...dsColor,
    neutral: {
      ...dsColor.neutral,
      main: dsColor.neutral['neutral-8'],
      contrastText: dsColor.neutral['neutral-2'],
    } as PaletteOptions['primary'] & DSColorType['neutral'],
    primary: {
      main: dsColor.galaxy['galaxy-8'],
    },
    secondary: {
      main: dsColor.nebula['nebula-8'],
    },
  },
  typography: {
    fontFamily: fondations.fontFamily.nunitoSans,
  },
}

export const customTheme = (options?: ThemeOptions) =>
  createTheme({
    ...themeOptions,
    ...options,
  })

const theme = customTheme(themeOptions)

export type AstroUIThemeType = Theme

export const useTheme = defaultUseTheme
export default theme
